<div
  [ngClass]="{
    'btn-group': gap === 'none',
    'flex': gap !== 'none',
    'flex-wrap': gap !== 'none' && wrap,
    'w-full': fullWidthMobile,
    'gap-1': gap === 'xs',
    'gap-2': gap === 'sm',
    'gap-3': gap === 'md'
  }">
  <ng-content></ng-content>
</div>
